import ScoreIllustration from '../../img/icons/score.svg';
class FormulaVisualManager {
    _selectorClass = '.js-Formula-Visual';
    _instances = [];
    init() {
        const nodes = $(this._selectorClass);
        if (!nodes.length)
            return;
        nodes.filter((node, element) => $(element).attr('data-rendered') === 'false')
            .each((node, element) => {
            const instance = FormulaVisualManager._createInstance($(element));
            if (instance)
                this._instances.push(instance);
        });
        this.render();
    }
    render() {
        this._instances.forEach(instance => {
            const percentage = 100 - instance.percentage;
            const node = instance.node.append(ScoreIllustration);
            const persons = node.find('svg .person');
            persons.slice(0, percentage)
                .each((index, element) => {
                $(element).addClass('person--active');
            });
            if (instance.half) {
                $(persons).last()
                    .removeClass('person--active')
                    .addClass('person--half');
            }
            node.attr('data-rendered', 'true');
        });
    }
    destroy() {
        this._instances.forEach(instance => {
            instance.node.remove();
        });
        this._instances = [];
    }
    static _createInstance(element) {
        const percentage = parseInt(element.attr('data-percentage'));
        const rendered = element.attr('data-rendered') === 'true';
        const half = element.attr('data-half') === 'true';
        if (!Number.isInteger(percentage)) {
            console.error('Percentage of formula visual is not an integer.', element);
            return null;
        }
        return {
            node: element,
            percentage,
            rendered,
            half
        };
    }
}
const formulaVisualManager = new FormulaVisualManager();
export { FormulaVisualManager, formulaVisualManager };
